import { ResourceType } from "../resources"
import tw, { css } from "twin.macro"
import Link from "next/link"

interface PageTitleProps {
  title: string
  type?: string
  parentTitle?: string
  parentUrl?: string
  centered?: boolean
  kicker?: string
}

export default function PageTitle(props: PageTitleProps) {
  const { title, type, parentTitle, parentUrl, centered, kicker } = props
  if (parentTitle) {
    return (
      <div tw="py-10 ">
        {parentUrl && (
          <p tw="font-sans text-3xl tablet:(text-h1) font-normal uppercase" css="letter-spacing: 0.04em;">
            <Link href={parentUrl} title="parentTitle" tw="hover:(no-underline)">
              {parentTitle}:
            </Link>
          </p>
        )}
        <h1 tw="font-sans text-3xl tablet:text-h1 font-normal" css="letter-spacing: 0em;">
          <span tw="text-rpd-gray-8" css={[type == ResourceType.Archival ? tw`text-rpd-blue` : tw`text-rpd-red`]}>
            {title}
          </span>
        </h1>
      </div>
    )
  }
  return (
    <div tw="pt-10 pb-6 space-y-4 font-sans tablet:(py-10)">
      {kicker && <p tw="text-center text-xl uppercase">{kicker}</p>}
      <h1
        tw="font-sans text-3xl tablet:text-h1 font-normal uppercase"
        css={[
          centered && tw`text-center`,
          css`
            letter-spacing: 0.04em;
          `,
        ]}
      >
        <span>{title}</span>
      </h1>
    </div>
  )
}
